<div class="legal-page">
  <header class="legal-header">
    <a routerLink="/landing" class="legal-header__brand">
      <div class="legal-header__logo"><mat-icon>point_of_sale</mat-icon></div>
      <span>Nova Point</span>
    </a>
    <a routerLink="/landing" class="legal-header__back">
      <mat-icon>arrow_back</mat-icon>
      Back to home
    </a>
  </header>

  <main class="legal-content">
    <h1>Terms of Service</h1>
    <p class="legal-content__updated">Last updated: {{ lastUpdated }}</p>

    <!-- <div class="legal-notice">
      <mat-icon>info</mat-icon>
      <p>
        This is a draft terms-of-service template provided as a starting point. It has not been
        reviewed by legal counsel and should not be treated as your final, binding terms until a
        qualified lawyer has reviewed it against your actual business practices and applicable law.
      </p>
    </div> -->

    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By creating an account or using Nova Point (the "Service"), you agree to be bound by these
        Terms of Service. If you do not agree, do not use the Service.
      </p>
    </section>

    <section>
      <h2>2. Description of Service</h2>
      <p>
        Nova Point provides a point-of-sale and business management platform, including sales,
        inventory, customer, expense, and reporting tools, along with optional fiscal device (TRA)
        integration for shops operating in Tanzania.
      </p>
    </section>

    <section>
      <h2>3. Account Registration &amp; Responsibilities</h2>
      <ul>
        <li>You must provide accurate information when registering and keep it up to date.</li>
        <li>You are responsible for maintaining the confidentiality of your login credentials.</li>
        <li>You are responsible for all activity that occurs under your account.</li>
        <li>You must be authorized to act on behalf of the business you register.</li>
      </ul>
    </section>

    <section>
      <h2>4. Subscription Plans &amp; Billing</h2>
      <ul>
        <li>Access to certain features requires an active paid subscription.</li>
        <li>Subscription fees are billed in advance for the plan's billing period and are
          processed through our third-party payment partners.</li>
        <li>Fees are non-refundable except where required by law.</li>
        <li>We may change subscription pricing with reasonable advance notice.</li>
      </ul>
    </section>

    <section>
      <h2>5. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for unlawful purposes or to process fraudulent transactions.</li>
        <li>Attempt to gain unauthorized access to the Service or other users' accounts.</li>
        <li>Interfere with or disrupt the integrity or performance of the Service.</li>
        <li>Reverse-engineer or resell the Service without our written permission.</li>
      </ul>
    </section>

    <section>
      <h2>6. Your Data</h2>
      <p>
        You retain ownership of the business data you enter into the Service (products, orders,
        customers, etc.). You grant us a license to host, process, and display that data solely to
        provide the Service to you, as described in our
        <a routerLink="/privacy-policy">Privacy Policy</a>.
      </p>
    </section>

    <section>
      <h2>7. Third-Party Services</h2>
      <p>
        The Service integrates with third-party providers, including payment gateways (e.g. Selcom,
        AzamPay) and the Tanzania Revenue Authority for fiscal reporting. Your use of those
        integrations is also subject to those providers' own terms.
      </p>
    </section>

    <section>
      <h2>8. Intellectual Property</h2>
      <p>
        The Service, including its software, design, and branding, is owned by Nova Point and
        protected by intellectual property laws. These Terms do not grant you any rights to our
        trademarks or branding.
      </p>
    </section>

    <section>
      <h2>9. Termination</h2>
      <p>
        You may stop using the Service at any time. We may suspend or terminate accounts that
        violate these Terms, engage in fraudulent activity, or where subscription payment fails and
        is not resolved within a reasonable grace period.
      </p>
    </section>

    <section>
      <h2>10. Disclaimers &amp; Limitation of Liability</h2>
      <p>
        The Service is provided "as is" without warranties of any kind. To the maximum extent
        permitted by law, Nova Point is not liable for indirect, incidental, or consequential
        damages arising from your use of the Service.
      </p>
    </section>

    <section>
      <h2>11. Governing Law</h2>
      <p>
        These Terms are governed by the laws of the United Republic of Tanzania, without regard to
        conflict-of-law principles, unless otherwise required by applicable local law.
      </p>
    </section>

    <section>
      <h2>12. Changes to These Terms</h2>
      <p>
        We may update these Terms from time to time. We will update the "Last updated" date above
        when we do. Continued use of the Service after changes means you accept the updated Terms.
      </p>
    </section>

    <section>
      <h2>13. Contact Us</h2>
      <p>
        Questions about these Terms? Email us at
        <a href="mailto:us@support.akiliunde.com">us@support.akiliunde.com</a>.
      </p>
    </section>
  </main>
</div>